<template>
  <section class="form-section mb-5">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="section-title mb-0">
        <i class="fas fa-briefcase me-2 text-primary"></i>
        Concesionarias y Cargos
      </h5>
      <button class="btn btn-sm btn-outline-primary shadow-sm hover-elevate" @click="$emit('add')" type="button">
        <i class="fas fa-plus me-1"></i> Asignar Concesionaria
      </button>
    </div>

    <div class="card border-0 shadow-sm bg-light transition-base"
      :class="{ 'border border-danger': errorMessage, 'shadow-error': errorMessage }">

      <div class="card-body p-0">
        <div class="table-responsive rounded">
          <table class="table table-hover align-middle mb-0 bg-white">
            <thead class="bg-light text-secondary text-uppercase small">
              <tr>
                <th class="border-0 py-3 ps-4">Concesionaria</th>
                <th class="border-0 py-3">CUIT</th>
                <th class="border-0 py-3">Cargos</th>
                <th class="border-0 py-3 text-center" style="width: 160px;">Rol</th>
                <th class="border-0 py-3 text-end pe-4" style="width: 80px;"></th>
              </tr>
            </thead>
            <tbody>

              <tr v-if="assignments.length === 0">
                <td colspan="5" class="text-center py-5">
                  <div class="mb-2">
                    <i class="fas fa-building fa-2x"
                      :class="errorMessage ? 'text-danger opacity-50' : 'opacity-25'"></i>
                  </div>
                  <span v-if="errorMessage" class="text-danger fw-bold">
                    Es necesario asignar al menos una concesionaria.
                  </span>
                  <span v-else class="text-muted">
                    No hay concesionarias asignadas.
                  </span>
                </td>
              </tr>

              <tr v-for="(item, index) in assignments" :key="index" :class="{ 'row-new': item._isNew }">
                <td class="ps-4">
                  <div class="d-flex flex-column align-items-start">
                    <span class="fw-bold text-dark">
                      {{ item.business_name }}
                      <template v-if="item.type == 1">(Casas Central)</template>
                      <template v-else>(Sucursal)</template>
                    </span>
                    <span v-if="item._isNew" class="badge bg-warning text-dark border border-warning mt-1 w-auto"
                      style="font-size: 0.65rem;">
                      <i class="fas fa-clock me-1"></i> Pendiente
                    </span>
                  </div>
                </td>
                <td class="text-monospace text-muted">{{ item.cuit }}</td>
                <td>
                  <div v-if="item.positions && item.positions.length > 0" class="d-flex flex-wrap gap-1">
                    <span v-for="pos in item.positions" :key="pos.id" class="badge bg-light text-dark border fw-normal">
                      {{ pos.name }}
                      <small v-if="pos.area" class="text-secondary ms-1 fw-semibold">({{ pos.area.name }})</small>
                    </span>
                  </div>
                  <div v-else>
                    <button @click="$emit('edit', index)"
                      class="btn btn-sm btn-link text-danger p-0 text-decoration-none fw-bold animate-pulse">
                      <i class="fas fa-exclamation-circle me-1"></i> Requerido
                    </button>
                  </div>
                </td>
                <td class="text-center">
                  <div class="d-flex flex-column align-items-center gap-1">
                    <div class="form-check form-switch mb-0">
                      <input class="form-check-input" type="checkbox" role="switch" :id="'adminSwitch-' + index"
                        :checked="item.concessionaire_admin"
                        @change="$emit('toggle-admin', index, $event.target.checked)"
                        style="width: 2.5em; height: 1.3em; cursor: pointer; margin-top: 0;">
                    </div>
                    <label :for="'adminSwitch-' + index" class="small cursor-pointer user-select-none mb-0"
                      :class="item.concessionaire_admin ? 'text-primary fw-bold' : 'text-muted'">
                      {{ item.concessionaire_admin ? 'Admin' : 'Usuario' }}
                    </label>
                  </div>
                </td>
                <td class="text-end pe-4">
                  <ActionDropdown>
                    <button class="dropdown-item" @click="$emit('edit', index)"><i
                        class="fas fa-edit text-primary me-2"></i>Editar</button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item text-danger" @click="$emit('remove', index)"><i
                        class="fas fa-trash-alt me-2"></i>Eliminar</button>
                  </ActionDropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ActionDropdown from "@/components/common/ActionDropdown.vue";

export default {
  name: 'UserAssignmentsList',
  components: { ActionDropdown },
  props: {
    assignments: {
      type: Array,
      default: () => []
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  emits: ['add', 'edit', 'remove', 'toggle-admin'],
  watch: {
    // Observamos los cambios en la prop 'assignments'
    assignments: {
      handler(newValue, oldValue) {
        console.log('--- UserAssignmentsList: Prop "assignments" actualizó ---');
        console.log('Nuevo valor:', JSON.parse(JSON.stringify(newValue))); // Usamos JSON.parse(stringify) para evitar ver un proxy reactivo y ver los datos reales
        console.log('Valor anterior:', oldValue ? JSON.parse(JSON.stringify(oldValue)) : 'undefined');
        console.log('Cantidad de concesionarias asignadas:', newValue.length);
      },
      deep: true, // Importante: true para detectar cambios *dentro* de los objetos del array (ej. cuando se agrega un cargo a una concesionaria)
      immediate: true // Importante: true para que se ejecute una vez apenas se monte el componente, no solo cuando cambia
    }
  }
};
</script>

<style scoped>
/* (El CSS se mantiene exactamente igual que el tuyo) */
.form-section {
  padding: 0 0.5rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #f1f3f5;
  padding-bottom: 0.75rem;
}

.text-monospace {
  font-family: 'SFMono-Regular', Consolas, monospace;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.row-new {
  background-color: #fff8e1 !important;
  border-left: 3px solid #ffc107;
}

.hover-elevate:hover {
  transform: translateY(-2px);
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
  transition: all 0.2s;
}

.gap-1 {
  gap: 0.25rem;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: .6;
  }
}


.form-section {
  padding: 0 0.5rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #f1f3f5;
  padding-bottom: 0.75rem;
  transition: color 0.3s;
}

.transition-base {
  transition: all 0.3s ease-in-out;
}

.shadow-error {
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.15) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>